import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  HostBinding
} from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';
import { IconFlagComponent } from '../../components/icon/icon-flag.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { MarketType } from '../../domain/market.domain';
import { SymbolType } from '../../domain/symbol.domain';

@Component({
  selector: 'td-wb-ticker-symbol',
  templateUrl: 'ticker-symbol.component.html',
  styleUrls: ['ticker-symbol.component.scss'],
  imports: [
    IconFlagComponent,
    NgClass,
    TranslatePipe,
    IconComponent,
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickerSymbolComponent {
  @Input() tickerSymbol: string;
  @Input() market?: MarketType; // CA, US -> show flag; else(undef, OTHER): disregard
  @Input() symbolType: SymbolType;
  @Input() description?: string; // To be displayed on the line below/after tickerSymbol, if exists
  @Input() multiAssetFund?: boolean;
  @Input() clickNotToggle: boolean = false;

  @Input()
  /* eslint-disable lines-between-class-members */
  @HostBinding('class.td-wb-ticker-symbol--single-line')
  set singleLine(value: boolean) { this._singleLine = value; }
  get singleLine(): boolean { return this._singleLine; }
  @Input()
  @HostBinding('class.td-wb-ticker-symbol--short-description')
  set shortDescription(value: boolean) { this._shortDescription = value; }
  get shortDescription(): boolean { return this._shortDescription; }
  @Input()
  set disabled(value: boolean) { this._disabled = value; }
  get disabled(): boolean { return this._disabled; }
  @Input()
  @HostBinding('class.td-wb-ticker-symbol--link')
  set symbolLink(value: boolean) { this._symbolLink = value; }
  get symbolLink(): boolean { return this._symbolLink; }
  /* eslint-enable lines-between-class-members */

  @Output() readonly onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() readonly onClick: EventEmitter<void> = new EventEmitter<void>();

  rowExpanded: boolean = false;
  private _disabled: boolean;
  private _singleLine: boolean = false;
  private _shortDescription: boolean = false;
  private _symbolLink: boolean = false;

  toggleExpandRow(): false {
    if (!this.disabled) {
      if (this.clickNotToggle) {
        this.onClick.emit();
      } else {
        this.rowExpanded = !this.rowExpanded;
        this.onToggle.emit(this.rowExpanded);
      }

    }
    return false;
  }

  // TODO: When backend returns type as OTHER for ALL mutual funds (on top movers),
  // we will be able to rewrite as: return market in [CA, US];
  // and remove the type from the @Input section
  showMarketFlag(): boolean {
    return this.symbolType !== SymbolType.MUTUALFUND && (this.market === MarketType.CA || this.market ===  MarketType.US);
  }

  showLink(): boolean {
    return !this.disabled && (this.onClick.observed || this.onToggle.observed);
  }
}
